import useSWR from 'swr';
import Auth from '../../../Auth';
import { useEffect, useState } from 'react';
import usePublicMode from '../../../hooks/usePublicMode';

export default function usePlugin(id) {
  const [plugin, setPlugin] = useState(null);
  const { urlPrefixApiPlugins } = usePublicMode();

  const { data, error, isLoading } = useSWR(`${urlPrefixApiPlugins}/api/plugins/${id}`, Auth.fetchWithIdToken);

  useEffect(() => {
    if (data && !isLoading) {
      setPlugin(data.plugin);
    }
  }, [data, isLoading]);

  return { plugin, isLoading, error };
}
